import { FlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const ServiceCard = styled(FlexDiv)`
    width: 150px;
    height: 200px;
    background-color: white;
    border-radius: 8px;
    flex-shrink: 0;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    cursor: pointer;
`
export const ServiceImageContainer = styled(FlexDiv)`
    width: 100%;
    height: 150px;
    justify-content: center;
    align-items: center;
    background-color: #F0F5FF;
    font-size: 20px;
    font-weight: bold;
    position: relative;
`
export const DetailContainer = styled(FlexDiv)`
    height: 50px;
    justify-content: center;
    padding-left: 8px;
    padding-right: 8px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
`
export const PriceLabel = styled.label`
    font-weight: bold;
    font-size: 12px;
`
export const NameLabel = styled.label`
    font-size: 13px;
`